// extracted by mini-css-extract-plugin
export default {"container":"Todo_container__TuXZr","completed":"Todo_completed__OWT-b","edit_btn":"Todo_edit_btn__hd4El","delete_btn":"Todo_delete_btn__WtGvK"};